import React from "react";
const pinIcon = "https://cdn.obsess-vr.com/vacheron/sections_icon_inactive+.svg";
const selectedPinIcon = "https://cdn.obsess-vr.com/vacheron/gold-sections-icons.svg";

const FloorPin = ({ x, y, sceneName, sceneId, handleClick, isActive, floorMapIndex }) => {
    return (
        <div className='scene-selection-container flex-center' style={{ transform: `translate(${x}px, ${y}px)` }} onClick={() => handleClick(sceneId,floorMapIndex)}>
            <div className='minimap-text'>{sceneName}</div>
            <div className='minimap-circle'>
                <img src={isActive ? selectedPinIcon : pinIcon} width="15" />
            </div>
        </div>
    )
}

FloorPin.propTypes = {
    x: PropTypes.string,
    y: PropTypes.string,
    isActive: PropTypes.bool,
    sceneName: PropTypes.string,
    handleClick: PropTypes.func,
    sceneId: PropTypes.string
}

export default FloorPin;